import { render, staticRenderFns } from "./modifyPassword.vue?vue&type=template&id=05082e4a&scoped=true"
import script from "./modifyPassword.vue?vue&type=script&lang=js"
export * from "./modifyPassword.vue?vue&type=script&lang=js"
import style0 from "./modifyPassword.vue?vue&type=style&index=0&id=05082e4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05082e4a",
  null
  
)

export default component.exports